import React, { useState, useEffect } from 'react';
import { IconPlus } from '@tabler/icons-react';
import CreateRool from './CreateRool';
import axios from 'axios';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAuth } from "../../../Context/store/context";
import globals from '../../../../globals';
const Roll = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedRoolId, setSelectedRoolId] = useState(null);
  const [roolSection, setRoolSection] = useState('');
    const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser } = useAuth();
    useEffect(() => {
      if (!getToken())
        logoutuser();
      updateTitleAndIcon(globals.Roll.title, globals.Roll.icon);
    }, []);
  const toggleDialog = (roolId = null) => {
    const matchedRool = roolSection.find((rool) => rool.roolId === roolId);
    setSelectedRoolId(matchedRool);
    setIsDialogOpen(true);
    
  };
  const handleDeleteData = async (roolId) => {
    try {
      const matchedRool = roolSection.find((rool) => rool.roolId === roolId);
      console.log("matchedRool", matchedRool.roolId);
  
      const response = await axios.delete(`http://localhost:4000/getrooldelete/${matchedRool.roolId}`);
      console.log(response.data.message);
      fetchRools();
    } catch (error) {
      console.error('Error deleting role:', error);
    }
  };
  
  const closeDialog = () => {
    setIsDialogOpen(false);
    setSelectedRoolId(null);
    fetchRools();
  };

  const fetchRools = async () => {
    try {
      const response = await axios.get(`http://localhost:4000/getrool`);
      console.log(response.data.Rool);
      setRoolSection(response.data.Rool);
     
    } catch (error) {
      console.error('Error fetching rools:', error);
    }
  };

  useEffect(() => {
    fetchRools();
  }, []);

  return (
    <div style={{ padding: "2%" }}>
      <div className="container-xxl container-p-y bs-stepper wizard-vertical wizard-numbered vertical mt-2 content-header mb-3 d-flex justify-content-between">
        <div className="sec-titler">
          <h2 className="text-primary">Create Role Page</h2>
          <div className="title-shape"></div>
        </div>
        <div className="mb-0 text-right">
          <button className="btn btn-primary align-middle" onClick={toggleDialog}>
            <IconPlus className="me-sm-1 me-0" size={20} />
            Create Role
          </button>
        </div>
      </div>

      <div className="mt-4">
        {Array.isArray(roolSection) && roolSection.length > 0 ? (
          roolSection.map((rool) => (
            <div key={rool._id} className="card mb-3 p-3">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <h5 className="text-primary">Role Name: {rool.roolname}</h5>
                </div>
                <div style={{ gap: "2%", display: "flex" }} >
                  <div>
                    <button className="btn btn-primary flex items-center" 
                    onClick={() => toggleDialog(rool.roolId)}>
                      <EditIcon fontSize="small" /> Edit
                    </button>
                  </div>
                  <div>
                    <button className="btn btn-primary align-middle flex items-center"
                     onClick={() => handleDeleteData(rool.roolId)}
                    >
                      <DeleteIcon className="me-sm-1 me-0" fontSize="small"
                       />
                      Delete
                    </button>
                  </div>
                </div>

              </div>
              <div>
                <h6>Permissions:</h6>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Section</th>
                      <th>View</th>
                      <th>Create</th>
                      <th>Edit</th>
                      <th>Delete</th>
                      <th>Export</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rool.name.map((item) => (
                      <tr key={item.customId}>
                        <td>{item.name}</td>
                        <td>
                          {item.view === 'true' ? (
                            <CheckCircleIcon style={{ color: 'green' }} />
                          ) : (
                            <CancelIcon style={{ color: 'red' }} />
                          )}
                        </td>
                        <td>
                          {item.create === 'true' ? (
                            <CheckCircleIcon style={{ color: 'green' }} />
                          ) : (
                            <CancelIcon style={{ color: 'red' }} />
                          )}
                        </td>
                        <td>
                          {item.edit === 'true' ? (
                            <CheckCircleIcon style={{ color: 'green' }} />
                          ) : (
                            <CancelIcon style={{ color: 'red' }} />
                          )}
                        </td>
                        <td>
                          {item.delete === 'true' ? (
                            <CheckCircleIcon style={{ color: 'green' }} />
                          ) : (
                            <CancelIcon style={{ color: 'red' }} />
                          )}
                        </td>
                        <td>
                          {item.export === 'true' ? (
                            <CheckCircleIcon style={{ color: 'green' }} />
                          ) : (
                            <CancelIcon style={{ color: 'red' }} />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))
        ) : (
          <p>No Rools Found</p>
        )}
      </div>

      {isDialogOpen && (
         <CreateRool roolId={selectedRoolId} onClose={closeDialog} />
      )}
    </div>
  );
}

export default Roll;
